import { z } from "zod";
export const CustomDomainLifecycleStateV1Schema = z.enum([
    "UNATTACHED",
    "PENDING_TXT",
    "TXT_VERIFIED",
    "SSL_PROVISIONING",
    "ACTIVE",
    "FAILED",
]);
export const CustomDomainLifecycleRecordV1Schema = z
    .object({
    schemaVersion: z.literal("custom-domain-lifecycle.v1.0"),
    domain: z.string().min(3),
    state: CustomDomainLifecycleStateV1Schema,
    txtRecordName: z.string().optional(),
    txtRecordValue: z.string().optional(),
    sslStatus: z.enum(["NOT_STARTED", "PROVISIONING", "ACTIVE", "FAILED"]).optional(),
    lastError: z.string().max(240).optional(),
    updatedAt: z.string().datetime(),
})
    .strict();
const ALLOWED_TRANSITIONS = {
    UNATTACHED: ["PENDING_TXT"],
    PENDING_TXT: ["TXT_VERIFIED", "FAILED"],
    TXT_VERIFIED: ["SSL_PROVISIONING", "FAILED"],
    SSL_PROVISIONING: ["ACTIVE", "FAILED"],
    ACTIVE: [],
    FAILED: ["PENDING_TXT"],
};
export function transitionCustomDomainLifecycle(current, nextState, patch, updatedAt) {
    const allowed = ALLOWED_TRANSITIONS[current.state];
    if (!allowed.includes(nextState)) {
        throw new Error(`custom_domain_transition_forbidden:${current.state}->${nextState}`);
    }
    return CustomDomainLifecycleRecordV1Schema.parse({
        ...current,
        ...patch,
        state: nextState,
        updatedAt,
    });
}
export function beginCustomDomainTxtVerification(domain, txtRecordName, txtRecordValue, updatedAt) {
    return CustomDomainLifecycleRecordV1Schema.parse({
        schemaVersion: "custom-domain-lifecycle.v1.0",
        domain,
        state: "PENDING_TXT",
        txtRecordName,
        txtRecordValue,
        sslStatus: "NOT_STARTED",
        updatedAt,
    });
}
//# sourceMappingURL=custom-domain-lifecycle.js.map